export const circle = {
    id: 'circle',
    width: 208,
    height: 208,
    d: 'M204 104C204 159.228 159.228 204 104 204C48.7715 204 4 159.228 4 104C4 48.7715 48.7715 4 104 4C159.228 4 204 48.7715 204 104Z',
};
